import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-end",
  "use": "icon-end-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-end\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0H24V24H0z\" />\n        <path fill=\"#FB5F52\" d=\"M11 11H19.5V13H11z\" />\n        <path stroke=\"#FB5F52\" d=\"M16 8L20 12 16 16M15 20H8.057C6.921 20 6 18.977 6 17.714V6.286C6 5.023 6.921 4 8.057 4H15\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol